import {checkIfCentralQuarter} from "../../buildings/checkIfCentralQuarter";
import {TOKENS_RESTRICTED_IN_FIRST_ROUND} from "../../../constants/tokens";

export const checkIfConstructionAllowedInRound = (token, round) => {
  if (round !== 1) {
    return true;
  }

  return !checkIfCentralQuarter(token) && !TOKENS_RESTRICTED_IN_FIRST_ROUND.includes(token);
}